"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-lock-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
            _react2.default.createElement("rect", { fill: "#4C4C4C", x: "11", y: "16", width: "14", height: "10", rx: ".889" }),
            _react2.default.createElement("path", { d: "M15 19.003a3 3 0 0 0 6 0v-6.006a3 3 0 0 0-6 0v6.006zm-2-6.006a5 5 0 0 1 10 0v6.006a5 5 0 0 1-10 0v-6.006z", fill: "#424242", fillRule: "nonzero" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-lock-on.js
// module id = 1846
// module chunks = 0